import VirtualDataList from 'commons/components/VirtualDataList';
import { TransferListRow, TransferMobileSkeleton } from './components';
import { useTransfersMobile } from '../../hooks';
import { TransferListPage } from '../components';

function TransferListMobilePage() {
  const {
    ids,
    data,
    showSkeleton,
    showSpinner,
    isDataEmpty,
    isError,
    refetch,
    handleInfiniteScroll,
    handlePullToRefresh,
  } = useTransfersMobile();

  return (
    <TransferListPage
      skeleton={<TransferMobileSkeleton />}
      isLoading={showSkeleton}
      isEmpty={isDataEmpty}
      isError={isError}
      onRetry={refetch}
    >
      <VirtualDataList
        onRefresh={handlePullToRefresh}
        isPullable
        data={ids}
        endReached={handleInfiniteScroll}
        itemContent={(index) => (
          <TransferListRow key={ids[index]} transfer={data[index]} />
        )}
        showFooter={showSpinner}
      />
    </TransferListPage>
  );
}

export default TransferListMobilePage;
